export function audioplayer(index, initial) {
  const crosswalk = index(window.CROSSWALK, (d) => d.key);

  // get all soundbite divs
  let soundbites = document.querySelectorAll('.soundbite');

  soundbites.forEach((x) => {
    let id = x.getAttribute('data-id');

    // get audio path
    let path = Object(crosswalk.get(id)).file;

    if (path) {
      let word = x.innerText;
      let bothwords = x.innerHTML;
      let justEnglish = id.replaceAll('_', ' ');
      let aria_content = `${word}: ${justEnglish} (select to play)`;
      // console.log(aria_content);

      x.setAttribute('aria-label', aria_content);
      x.setAttribute('aria-pressed', false);
      if (initial) {
        x.innerHTML = `
          <span class="progress" aria-hidden="true"></span>
          <span class="btn-word">    
            <span class="playpause" aria-hidden="true">
                <img class="icon-play" alt="play button icon" src="${window.PLAY_ICON}" aria-hidden="false">
                <img class="icon-pause" alt="pause button icon" src="${window.PAUSE_ICON}" aria-hidden="true">
              <audio class="audio-player" preload="none">
                <source src="${path}" type="audio/mpeg" />
                Your browser does not support the audio tag.
              </audio>
            </span>
            ${bothwords}
            </span>
            `;
      }
    }
  });

  if (initial) {
    prepAudioElements();
  }
}

function prepAudioElements() {
  //it's not playing by default

  let playing = false;
  let audio;

  document.querySelectorAll('.soundbite').forEach((item) => {
    item.addEventListener('click', playAudio, false);
  });

  function playAudio() {
    // test if there is something active or nothing active yet
    if (document.querySelector('.soundbite.active')) {
      // there is alsready an audio playing that is not the one we just clicked
      if (!this.classList.contains('active')) {
        // console.log('new audio');
        stopAnyOtherAudio();
      }
    } else {
      // console.log('new');
    }

    let player = this; // button
    const arialabel = player.getAttribute('aria-label');
    // console.log(arialabel);

    changeIcon(player);

    function changeIcon(player) {
      player.classList.toggle('playing');
      player.classList.add('active');
      let playIcon = player.querySelector('.icon-play');
      let pauseIcon = player.querySelector('.icon-pause');
      playPause(player);

      if (playing == false) {
        // console.log('playing');
        playIcon.setAttribute('aria-hidden', 'false');
        pauseIcon.setAttribute('aria-hidden', 'true');
        playing = true;
      } else {
        // console.log('pausing');
        playIcon.setAttribute('aria-hidden', 'true');
        pauseIcon.setAttribute('aria-hidden', 'false');
        playing = false;
      }
    }

    function handlePlay(audio, player, aria_content) {
      audio.play();
      player.classList.remove('paused');
      player.setAttribute('aria-pressed', 'true');
      player.setAttribute('aria-label', aria_content);
    }

    function playPause(player, container) {
      // get the id of the audio tag
      audio = player.querySelector('audio');

      //if it's already paused, we want it to play
      if (audio.paused) {
        let updated_arialabel = arialabel.replace('play', 'pause');
        handlePlay(audio, player, updated_arialabel);
      }
      //otherwise, it's playing and we want it to pause
      else {
        audio.pause();
        player.classList.add('paused');
        player.setAttribute('aria-pressed', 'false');

        player.setAttribute('aria-label', arialabel);
      }

      audio.onended = function () {
        player.classList.remove('active');
        player.classList.remove('playing');
        let playIcon = player.querySelector('.icon-play');
        let pauseIcon = player.querySelector('.icon-pause');
        playIcon.setAttribute('aria-hidden', 'false');
        pauseIcon.setAttribute('aria-hidden', 'true');
        player.setAttribute('aria-pressed', 'false');
        player.setAttribute('aria-label', arialabel);
        playing = false;
        //change the play/pause
      };

      ['timeupdate', 'seek'].forEach((ev) =>
        audio.addEventListener(ev, onTime)
      );
    }
    // PROGRESS CIRCLE //
    function onTime() {
      // get the duration of the audio file and find the ratio
      var audioDuration = audio.duration;
      player.querySelector('.progress').style.animationDuration =
        audioDuration + 's';
    }

    function stopAnyOtherAudio() {
      // set playing to false
      playing = false;
      // turn off all other audio and reset it
      // get all the soundbite elements
      document.querySelectorAll('.soundbite').forEach((a) => {
        let audioEl = a.querySelector('audio');
        // if it has audio in it (b/c draft)
        if (audioEl) {
          // if audio is playing, pause and reset it
          if (!audioEl.paused || audioEl.currentTime > 0) {
            audioEl.pause();
            audioEl.currentTime = 0;
            a.classList.remove('active');
            a.classList.remove('playing');
            a.classList.remove('paused');
            a.setAttribute('aria-pressed', 'false');
          }
        }
      });
    }
  }
}
